import React from 'react';
import { bandFor } from '../../../utils/powerScoreBands';

/* Compact Power Score row inside the Recruit ▸ Me card, above the stat groups.
   Ported from PowerScoreStrip in the apps.

   `score` is the whole power_score OBJECT from /athletes/profile —
   { score, speed, explosion, agility, size, verification, version, computed_at }
   (backend/app/services/power_score.py serialize_power_score) — not a number.
   Same contract as PowerScoreCard, which also takes the object and reads
   .score. Treating it as a number crashed /recruit?mode=me with "Objects are
   not valid as a React child".

   The full card stays on /measurables; this is the glanceable version, and
   tapping it opens the explainer. */

export default function PowerScoreStrip({ score, onExplain }) {
  const value = score && score.score;
  if (value == null) return null;
  const band = bandFor(value);

  return (
    <button
      type="button"
      className="me-power"
      onClick={onExplain}
      data-testid="recruit_me_power_strip"
      aria-label={`Power Score ${value}, ${band ? band.label : ''}. What this means`}
    >
      <span className="me-power__score" style={band ? { color: band.color } : undefined}>{value}</span>
      <span className="me-hubrow__body">
        <span className="me-power__band">{band ? band.label : ''}</span>
        <span className="me-power__sub">Rises as you fill the groups below.</span>
      </span>
    </button>
  );
}
